import type { Translations } from "@/lib/i18n/types";

/**
 * Maps a raw issue-save error to a user-friendly, translated message.
 *
 * Some validation rules live in a Postgres trigger (`pm_issues_validate_parent`)
 * and surface only as a raw `RAISE EXCEPTION` string — e.g.
 * `pm_issues with existing subissues cannot become a subissue itself (id=35)`.
 * Those are matched here and swapped for a clean translated sentence; anything
 * unrecognised falls back to the original message (WHA-3455).
 */
export function friendlyIssueError(err: unknown, t: Translations): string {
  const message = err instanceof Error ? err.message : String(err ?? "");

  // Rule 0 (WHA-3404): an issue that already has subissues cannot itself
  // become a subissue.
  if (message.includes("cannot become a subissue itself")) {
    return t.pm.issues.errors.parentHasSubissues;
  }

  return message || "Failed to save";
}
